import React, { useState } from 'react';
import { Card, makeStyles, CardContent, Button, CircularProgress, useTheme } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
import DoneIcon from '@material-ui/icons/Done';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import { LinearProgressWithLabel } from '../Shared';
import { useDispatch } from 'react-redux';
import { challengeActions } from '../../actions';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '../Shared';

const useStyles = makeStyles((theme) => ({
  header: {
    padding: theme.spacing(1),
    color: theme.palette.neutrals.low.medium,
    fontSize: 13,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  icon: {
    // backgroundColor: '#7E0386',
    width: 40,
    height: 40,
    borderRadius: '50%',
    marginRight: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    fontSize: 14,
    fontWeight: 600,
  },
  line: {
    borderLeft: '3px solid',
    height: 16,
    position: 'absolute',
    left: 27,
    top: -8,
  },
  containerButton: {
    marginTop: 30,
  },
  circleProgress: {color: theme.palette.primary.main, marginRight: 10}
}));

function ChallengeProgressCard(props) {
  const classes = useStyles();
  const {
    challenge,
    imagem,
    criteria,
    dates,
    award,
    progress,
  } = props.progress;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const theme = useTheme();

  function handleLoadingButton() {
    setLoading(!loading);
  }

  function color(color) {
    switch (color) {
      case 'active':
        return theme.palette.primary.main;

      case 'concluded':
        return theme.palette.neutrals.low.medium;

      case 'disabled':
        return theme.palette.neutrals.low.light;

      default:
        return 'grey';
    }
  }

  function colorIcon(color) {
    switch (color) {
      case 'active':
        return '#7E0386';

      case 'concluded':
        return '#00C766';

      case 'disabled':
        return '#D5D5D5';

      default:
        return 'grey';
    }
  }

  function sendChallenge() {
    dispatch(challengeActions.createChallenge(props.challenge,t('seu_desafio_foi_criado')));
  }

  return (
    <Card>
      <CardContent>
        <div className={classes.header}>{t('progresso_do_casdastro')}</div>
        <div>
          {/* challange */}
          <div style={{ display: 'flex', padding: 8 }}>
            <div
              className={classes.icon}
              style={{ backgroundColor: colorIcon(challenge) }}
            >
              {challenge === 'active' && (
                <DescriptionIcon style={{ color: 'white' }} />
              )}
              {challenge === 'concluded' && (
                <DoneIcon style={{ color: 'white' }} />
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className={classes.text} style={{ color: color(challenge) }}>
                {t('desafio')}
              </div>
            </div>
          </div>
          {/* imagem */}
          <div style={{ display: 'flex', padding: 8, position: 'relative' }}>
            <div
              className={classes.line}
              style={{ color: colorIcon(imagem) }}
            ></div>
            <div
              className={classes.icon}
              style={{ backgroundColor: colorIcon(imagem) }}
            >
              {imagem === 'active' && (
                <AddAPhotoIcon style={{ color: 'white' }} />
              )}
              {imagem === 'concluded' && (
                <DoneIcon style={{ color: 'white' }} />
              )}
              {imagem === 'disabled' && (
                <AddAPhotoIcon style={{ color: 'white' }} />
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className={classes.text} style={{ color: color(imagem) }}>
                {t('imagem')}
              </div>
            </div>
          </div>

          {/* criteria */}
          <div style={{ display: 'flex', padding: 8, position: 'relative' }}>
            <div
              className={classes.line}
              style={{ color: colorIcon(criteria) }}
            ></div>
            <div
              className={classes.icon}
              style={{ backgroundColor: colorIcon(criteria) }}
            >
              {criteria === 'active' && (
                <AssignmentTurnedInIcon style={{ color: 'white' }} />
              )}
              {criteria === 'concluded' && (
                <DoneIcon style={{ color: 'white' }} />
              )}
              {criteria === 'disabled' && (
                <AssignmentTurnedInIcon style={{ color: 'white' }} />
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className={classes.text} style={{ color: color(criteria) }}>
                {t('criterios')}
              </div>
            </div>
          </div>

          {/* data */}
          <div style={{ display: 'flex', padding: 8, position: 'relative' }}>
            <div
              className={classes.line}
              style={{ color: colorIcon(dates) }}
            ></div>
            <div
              className={classes.icon}
              style={{ backgroundColor: colorIcon(dates) }}
            >
              {dates === 'active' && (
                <AssignmentIcon style={{ color: 'white' }} />
              )}
              {dates === 'concluded' && <DoneIcon style={{ color: 'white' }} />}
              {dates === 'disabled' && (
                <AssignmentIcon style={{ color: 'white' }} />
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className={classes.text} style={{ color: color(dates) }}>
                {t('datas')}
              </div>
            </div>
          </div>

          {/* awards */}
          <div style={{ display: 'flex', padding: 8, position: 'relative' }}>
            <div
              className={classes.line}
              style={{ color: colorIcon(award) }}
            ></div>
            <div
              className={classes.icon}
              style={{ backgroundColor: colorIcon(award) }}
            >
              {award === 'active' && (
                <EmojiEventsIcon style={{ color: 'white' }} />
              )}
              {award === 'concluded' && <DoneIcon style={{ color: 'white' }} />}
              {award === 'disabled' && (
                <EmojiEventsIcon style={{ color: 'white' }} />
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className={classes.text} style={{ color: color(award) }}>
                {t('premiacao')}
              </div>
            </div>
          </div>

          {/* progress bar */}
          <LinearProgressWithLabel value={progress}></LinearProgressWithLabel>

          {/* button publicar */}
          <div className={classes.containerButton}>
            {loading ? 
              <LoadingButton />
            : 
              <Button
                style={{ width: '100% '}}
                variant="contained"
                color="primary"
                onClick={() => { handleLoadingButton(); sendChallenge(); }}
                disabled={progress !== 100}
              >
                {t('publicar_desafio')}
              </Button>
            }
            
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export { ChallengeProgressCard };
